__webpack_require__.p = "pigment-cdn.customink.com/products/assets/packs/";